export default {"src":"/_next/static/media/pardugo-icon.b4b397c9.svg","height":346,"width":346};